<template>
  <v-row>
    <v-col cols="12">
      <template v-for="(ep, i) in visibleItems">
        <v-expand-transition :key="i">
          <v-row v-if="!ep.dependsOn || (ep.dependsOn && isDependsOnDone(ep))">
            <v-col :cols="ep.deepnessLevel" v-if="ep.deepnessLevel > 0">
            </v-col>
            <v-col :cols="12 - ep.deepnessLevel">
              <v-row>
                <template v-if="ep.type === 'title'">
                  <v-col
                    cols="12"
                    class="align-center justify-space-between mt-5 mb-5"
                  >
                    <span
                      class="text-subtitle-1 font-weight-bold"
                      v-html="ep.title"
                    ></span>
                  </v-col>
                </template>
                <template v-else-if="ep.type === 'text'">
                  <v-col cols="12" class="align-center justify-space-between">
                    <v-text-field
                      :label="ep.title"
                      v-model="ep.textValue"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </template>
                <template v-else-if="ep.type === 'switch'">
                  <v-col
                    cols="12"
                    class="d-flex align-center justify-space-between"
                  >
                    <span v-html="ep.title"></span>
                    <v-switch
                      class="mt-0 pt-0"
                      hide-details
                      v-model="ep.done"
                      @change="markChildrenDoneNull(ep)"
                    ></v-switch>
                  </v-col>
                </template>
                <template v-else>
                  <v-col
                    cols="12"
                    md="8"
                    class="d-flex align-center"
                    v-html="ep.title"
                  >
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex justify-end">
                    <v-btn-toggle
                      v-model="ep.done"
                      color="info"
                      dense
                      mandatory
                      @change="markChildrenDoneNull(ep)"
                    >
                      <v-btn
                        v-for="(level, key) in ep.levels"
                        :key="key"
                        :value="parseInt(key)"
                        :color="getColor(ep, parseInt(key))"
                      >
                        {{ level }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-expand-transition>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RiskAssessment",
  props: {
    value: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      default: "execution", // 'execution' (Digivihko) or 'planning' (Harjoitussuunnitelma)
    },
  },
  computed: {
    visibleItems() {
      if (this.mode === "planning") {
        return this.value.filter((item) => item.mode !== "execution");
      }
      return this.value;
    },
  },
  methods: {
    getColor(ep, value) {
      if (ep.done === value) {
        if (value === 2) return "success";
        if (value === 0) return "error";
        return "warning";
      }
      return "";
    },
    markChildrenDoneNull(ep) {
      if (ep.done === false || ep.done === null) {
        this.value.forEach((hc) => {
          if (hc.dependsOn === ep.id) {
            hc.done = hc.type === "switch" ? false : null;
            this.markChildrenDoneNull(hc);
          }
        });
      }
    },
    isDependsOnDone(ep) {
      const dependentOn = this.value.find((hc) => hc.id === ep.dependsOn);
      if (!dependentOn) return true;
      if (dependentOn.type === "switch") return dependentOn.done;
      return dependentOn.done === 2; // Assuming 2 is "Yes"/"OK" which enables children
    },
  },
};
</script>

<style scoped></style>
